import { render } from "./SurveyModal.vue?vue&type=template&id=1a31c676&scoped=true"
import script from "./SurveyModal.vue?vue&type=script&lang=js"
export * from "./SurveyModal.vue?vue&type=script&lang=js"

import "./SurveyModal.vue?vue&type=style&index=0&id=1a31c676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a31c676"]])

export default __exports__